/*eslint-disable*/
module.exports = {
  innerReferences: 'References with inner references are not allowed.',
  circularReference: 'There appears to be a circular reference, maximum reference following exceeded.'
};